import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { useNavigationContext } from '../NavigationContext/NavigationContext.esm.js';
import { Collapse } from './Collapse.esm.js';
import { navActions } from './reducer.esm.js';

function BottomNav({ children, addClassName, dataMetrics, dataTestId }) {
    const { collapsed, dispatch, openedNav } = useNavigationContext();
    return (React.createElement("ul", { "data-metrics": dataMetrics, "data-testid": dataTestId || "bottom-nav", className: classNames("tw-box-border tw-list-none tw-m-0 tw-p-0 tw-border-0", addClassName) },
        React.createElement("div", { className: classNames("tw-ml-1.5 tw-border-solid tw-border-0 tw-border-t spf-nav-border-separator-color", collapsed ? "tw-w-9" : "spf-nav-w-[248px] spf-nav-ml-[12px]") }),
        children,
        React.createElement(Collapse, { collapsed: collapsed, changeCollapse: () => dispatch({ type: navActions.toggleCollapse }), subnavOpened: !!openedNav })));
}

export { BottomNav };
//# sourceMappingURL=BottomNav.esm.js.map
